module.exports = __webpack_public_path__ + "static/media/logo-footer1.1e5846ad.png";